import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {newsletterMailView_template} from "../components/templates/newsletterMailView_template";

declare var ko: any;
declare var page: any;
declare var CKEDITOR: any;
CKEDITOR.timestamp = '1.2.0';

let contentEditor;

export class newsletter_mail_view extends vnModule_knockoutJS {

    protected newsletterMailView: newsletterMailView_template;
    protected XHRHdl: XMLHttpRequestHandler;

    buildContent(): Array<Element> {
        this.newsletterMailView = new newsletterMailView_template("newsletter_mail_view_template", this.viewModel, this);
        return [this.newsletterMailView.build()];
    }

    protected getModuleName(): string {
        return "newsletter_mail_view_template";
    }

    fillPage() {
        this.getNewsletterReferences()
    }

    private getNewsletterMailDataForView() {

        this.loadingIn(this.newsletterMailView.builtTemplate);

        let url : string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/emails/get/' + this.getVnAppZone().app.params.id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetNewsletterMailDataForView;
        this.XHRHdl.execute();
    }

    private onGetNewsletterMailDataForView(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                let newsletterMail = responseParsed.mail;
                obj.newsletterMailView.setNewsletterMailData(newsletterMail);

            });

            obj.loadingOut(obj.newsletterMailView.builtTemplate);
        }
    }

    protected getNewsletterReferences() {

        // LOADING : starts
        this.loadingIn(this.newsletterMailView.builtTemplate);

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/references';
        let usrReq_params: Array<Array<string>> = [['references', 'permissions']];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onNewsletterRequestReturn;
        this.XHRHdl.execute();
    }

    public onNewsletterRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                obj.loadingOut(obj.newsletterMailView.builtTemplate);

                //check if user has article write permissions
                let responseParsed = JSON.parse(req.request.response);

                obj.newsletterMailView.setPermissions(responseParsed.permissions)

                obj.getNewsletterMailDataForView()
            })
        }
    }

    protected onClickEditNewsletterMail(id){
        let brandId = this.getVnAppZone().app.params.idBrand
        page("/brand/" + brandId + "/newsletter/emails/edit/" + id + '/')
    }

    protected onClickCancel(){
        let brandId = this.getVnAppZone().app.params.idBrand
        page.redirect("/brand/" + brandId + "/newsletter/emails/")
    }
}


// WEBPACK FOOTER //
// ./js/modules/newsletter_mail_view.ts